import './navigation.css';

export default function Navigation({ className, children }) {
    return (
        <nav className={`tab-nav ${className ? className : ''}`}>
            {children}
        </nav>
    );
}